import { render, staticRenderFns } from "./wawamanage.vue?vue&type=template&id=3d464a2d"
import script from "./wawamanage.vue?vue&type=script&lang=js"
export * from "./wawamanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports